import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.grey[400],
      },
      "&:hover fieldset": {
        borderColor: theme.palette.jigsaw.green,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.jigsaw.green,
        borderWidth: 2,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.grey[600],
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.jigsaw.green,
    },
  }));


export const DropBoxContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    width: "25%",
    alignItems: "center",
    justifyContent: "center",
    marginLeft:"10px",
    padding: "15px",
}));